<template>
  <div class="x-legend">
    <v-icon size="small" class="icon-color" :icon="CONSTANTS.ICONS_MDI.ICON_DOTS_VERTICAL" />
  </div>
</template>

<script lang="ts" setup>
  import CONSTANTS from '@/constants/Config.constants'
</script>

<style lang="scss" scoped>
  .x-legend {
    color: rgb(var(--v-theme-grey-medium));

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .icon-color {
    color: rgb(var(--v-theme-grey-medium));
  }
</style>
